@import '../../global/style/utilities/globals';

:host {
  /**
  * @prop --color: defaults to current context color
  * @prop --primary-color: used for duotone icons to set the primary color
  * @prop --secondary-color: used for duotone icons to set the secondary color
  * @prop --primary-opacity: used for duotone icons to set the primary opacity
  * @prop --secondary-opacity: used for duotone icons to set the secondary opacity
  * @prop --stroke-width: 32px default stroke width
  */

  --color: var(--nano-color-base, 'currentColor');
  --primary-color: var(--nano-color-tint, 'currentColor');
  --secondary-color: var(--nano-color-shade, 'currentColor');
  --stroke-width: 32px;
  --primary-opacity: 0.8;
  --secondary-opacity: 1;
  --icon-size: var(--nano-icon-size, 1em);
  --icon-margin-top: var(--nano-icon-margin-top, 0);
  --icon-margin-end: var(--nano-icon-margin-end, 0);
  --icon-margin-bottom: var(--nano-icon-margin-bottom, 0);
  --icon-margin-start: var(--nano-icon-margin-start, 0);

  display: inline-block;
  width: var(--icon-size);
  height: var(--icon-size);
  min-width: var(--icon-size);
  min-height: var(--icon-size);
  contain: strict;
  fill: currentColor;
  box-sizing: content-box !important;
  transition: opacity 0.3s ease;
  color: var(--color);
  margin-inline: var(--icon-margin-start) var(--icon-margin-end);
  margin-block: var(--icon-margin-top) var(--icon-margin-bottom);
}

:host .nanoicon {
  stroke: currentColor;
}

.nanoicon-fill-none {
  fill: none;
}

.nanoicon-stroke-width {
  stroke-width: 32px;
  stroke-width: var(--stroke-width);
}

.icon-inner,
.nanoicon,
svg,
.svg {
  display: block;
  height: 100%;
  width: 100%;
  overflow: visible;
}

:host(.loading) {
  opacity: 0;
}

.fa-primary {
  color: var(--primary-color);
  opacity: var(--primary-opacity, 1);
}

.fa-secondary {
  color: var(--secondary-color);
  opacity: var(--secondary-opacity) !important;
}

/* Icon RTL
 * -----------------------------------------------------------
 */
:host(.flip-rtl) .icon-inner {
  transform: scaleX(-1);
}

/* Icon Sizes
 * -----------------------------------------------------------
 */
:host(.icon-small) {
  font-size: 18px !important;
}

:host(.icon-large) {
  font-size: 32px !important;
}
